<script>
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
export default {
  name: 'DetailBox',

  functional: true,

  components: { VSvgIcon },

  props: {
    mandatory: {
      type: Boolean,
      required: false,
    },

    headline: {
      type: [Number, String],
      required: false,
      default: null,
    },

    label: {
      type: [Number, String],
      required: false,
      default: null,
    },

    icon: {
      type: String,
      required: false,
      default: null,
    },

    positive: {
      type: Boolean,
    },

    negative: {
      type: Boolean,
    },

    width: {
      type: Number,
      required: false,
      default: 1,
    },

    table: {
      type: Boolean,
      required: false,
    },

    tag: {
      type: String,
      required: false,
      default: 'div',
    },
  },

  render(h, { parent, props, data, listeners, scopedSlots }) {
    const content = scopedSlots.default && scopedSlots.default();
    if (!content && !props.mandatory) return;

    const headlineContent =
      (scopedSlots.headline && scopedSlots.headline()) || (props.headline && h('span', { domProps: { innerHTML: parent.$to(props.headline) } }));
    const headline = headlineContent && h('h5', { staticClass: 'h4 db-hl text-center' }, [headlineContent]);
    const icon =
      props.icon &&
      (() => {
        const normalize = (val) =>
          String(val || '')
            .trim()
            .split(/\s+/)[0]
            .replace(/^icon-/, '')
            .toLowerCase();

        const iconStatus = normalize(props.icon);
        const mapIconStatus = {
          reserved: 'clock',
          locked: 'lock',
          active: 'confirm',
          inactive: 'clock',
          optin: 'section',
          terminated: 'cancel',
          failed: 'error',
          information: 'information',
          info: 'information',
          success: 'confirm',
          warning: 'cancel',
          error: 'cancel',
        };

        const name = mapIconStatus[iconStatus] || iconStatus || 'information'; // fallback to 'information'

        return h('div', { staticClass: 'notification-left', style: { display: 'flex', alignItems: 'center' } }, [
          h('div', { staticClass: 'icon-frame' }, [
            h(VSvgIcon, {
              props: {
                name,
                variant: 'outlined',
                size: 'large',
                pointerEvents: 'auto',
              },
              attrs: { 'aria-hidden': true, role: 'img' },
            }),
          ]),
        ]);
      })();

    const label = (scopedSlots.label && scopedSlots.label()) || (props.label && h('span', { domProps: { innerHTML: parent.$to(props.label) } }));
    const contentWrapper = h('div', { staticClass: 'notification-content' }, [h('div', { staticClass: 'notification-heading' }, [label]), content]);

    const notificationChildren = [
      h('div', { staticClass: 'notification-inner', class: { table: props.table, 'heading-spacing': !scopedSlots.label && !props.label && props.icon } }, [
        icon,
        contentWrapper,
      ]),
    ];
    const grayed = scopedSlots.grayed && scopedSlots.grayed();

    if (grayed) notificationChildren.push(h('div', { staticClass: 'grayed' }, [grayed]));

    const rootData = {};
    if (data?.ref) {
      // if ref is provided, put it only on root node and make it focusable
      rootData.ref = data.ref;
      delete data.ref;
      rootData.attrs = {
        tabindex: -1,
      };
    }

    const notification = h(
      'div',
      {
        staticClass: 'notification',
        data,
        on: listeners,
        class: { 'notification-positive': props.positive, 'notification-negative': props.negative, 'subtract-db-hl': scopedSlots.headline || props.headline },
      },
      notificationChildren
    );

    return h(
      props.tag,
      {
        ...rootData,
        staticClass: 'col-s-12 box',
        class: { 'col-l-12 col-m-12': props.width === 3, 'col-l-8 col-m-6': props.width === 2, 'col-l-4 col-m-6': props.width === 1 },
      },
      [h('div', { staticClass: 'inner-aligned' }, [headline, notification])]
    );
  },
};
</script>

<style lang="scss" scoped>
.notification-inner {
  display: flex;
  align-items: stretch;
  min-height: 3em;
  padding: 1em;
  line-height: 1.4;
}

.icon-frame {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin-right: 0.5em;
}

.notification-content {
  line-height: 1.5;
}
</style>
